export const redirectToWA = ({ name, email, phone, product, qty, total, currency }: { name: string; email: string; phone: string; product: string; qty: number; total: number; currency: string }) => {
  const message = `
  Hello Admin,
  
  I would like to place an order:
  
  Name: ${name}
  Email: ${email}
  Phone: ${phone}
  
  Product: ${product}
  Quantity: ${qty}
  
  Total Payment: ${currency} ${total.toFixed(2)}
  
  Please assist me with this order. Thank you.
  `;

  const url = `https://wa.me/62895352380652?text=${encodeURIComponent(message)}`;
  //   const url = `https://wa.me/6281210681178?text=${encodeURIComponent(message)}`;

  window.open(url, "_blank");
};
